import React from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { BASE_URL } from '../../config';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Markup } from 'interweave';
// import { Carousel } from 'react-responsive-carousel';
function Banner({data}) {
    const options = {
        loop: true,
        margin: 0,
        height:600,
        items: 1,
        autoplay: true,
        autoplaySpeed:1200,
        rewind: false,
        lazyLoad:true,
        // navRewind: true,
              autoplayTimeout:6000,
              navSpeed: 2000,
              dragEndSpeed: 2000,
              dots: false,
              nav: false
      };
  return (
    <section className="bannercontainer">
  <div id="HomeBanner" className="owl-carousel owl-theme owl-loaded" >
 
  <OwlCarousel className="owl-theme" {...options}  style={{maxHeight:"600px",overflow:"hidden"}}>
  {data?.length>0&&data?.map((el,idx)=>{
    return  <div key={idx} className="item">
    {/* <img src={`${BASE_URL}/${el.image}`} width="1425" height="600" alt="" /> */}
    <LazyLoadImage
      alt=""
      src={`${BASE_URL}/${el.image}`} 
      // width={1920} 
      // height={840}
      />
    <div className="tpbannercaption">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="tpbnheading">{el.name}</div>
          </div>
        </div>
      </div>
    </div>
    <div className="bannercaption">
      <div className="container">
        <div className="row">
          <div className="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-10 col-12">
            <div className="captioninner ">
              <Markup content={el.description}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
      })}

  </OwlCarousel>
     {/* </Carousel> */}
    
   
  </div>
</section>
  )
}

export default Banner